"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_table_1 = require("react-table");
var Styled = __importStar(require("./Table.styled"));
var helpers_1 = require("./helpers");
function Table(_a) {
    var className = _a.className, data = _a.data, columns = _a.columns, pageSize = _a.pageSize, pageIndex = _a.pageIndex, config = _a.config, globalFilter = _a.globalFilter, onRowsCountChange = _a.onRowsCountChange;
    var tableContainerRef = react_1.useRef(null);
    var tableGlobalFilter = react_1.useMemo(function () {
        if (!config.globalFilterDetector)
            return undefined;
        return function (rows, columnIds, filterValue) {
            return rows.filter(function (row) {
                return config.globalFilterDetector(row.values, filterValue);
            });
        };
    }, [config]);
    var _b = react_table_1.useTable({
        columns: columns,
        data: data,
        initialState: {
            pageSize: pageSize,
            pageIndex: pageIndex,
        },
        globalFilter: tableGlobalFilter,
    }, react_table_1.useGlobalFilter, react_table_1.usePagination), getTableProps = _b.getTableProps, getTableBodyProps = _b.getTableBodyProps, headerGroups = _b.headerGroups, page = _b.page, rows = _b.rows, prepareRow = _b.prepareRow, gotoPage = _b.gotoPage, setPageSize = _b.setPageSize, setGlobalFilter = _b.setGlobalFilter;
    react_1.useEffect(function () {
        gotoPage(pageIndex);
        setPageSize(pageSize);
    }, [gotoPage, setPageSize, pageIndex, pageSize]);
    react_1.useEffect(function () {
        setGlobalFilter(globalFilter);
    }, [globalFilter, setGlobalFilter]);
    react_1.useEffect(function () {
        onRowsCountChange(rows.length);
    }, [onRowsCountChange, rows.length]);
    var _c = react_1.useMemo(function () { return helpers_1.buildHeader(columns, config.isStickyHeader, headerGroups); }, [columns, config.isStickyHeader, headerGroups]), renderedHeader = _c.renderedHeader, originalColumns = _c.originalColumns;
    var renderedRows = react_1.useMemo(function () { return helpers_1.buildRows(page, prepareRow, originalColumns); }, [page, prepareRow, originalColumns]);
    react_1.useEffect(function () {
        var hasStickyColumn = originalColumns.some(function (col) { return col.sticky; });
        if (hasStickyColumn) {
            helpers_1.setStickyColumnCellPosition(tableContainerRef.current);
        }
        if (config.isStickyHeader) {
            helpers_1.setStickyHeaderCellPosition(tableContainerRef.current);
        }
    });
    var isStickyColumn = columns.some(function (col) { return col.sticky; });
    return (react_1.default.createElement(Styled.TableContainer, { ref: tableContainerRef, className: className, isOverflow: config.isStickyHeader || isStickyColumn },
        react_1.default.createElement(Styled.Table, __assign({ isOverflow: config.isStickyHeader || isStickyColumn }, getTableProps()),
            react_1.default.createElement("thead", null, renderedHeader),
            react_1.default.createElement("tbody", __assign({}, getTableBodyProps()), renderedRows))));
}
Table.defaultProps = {
    pageSize: 10,
    pageIndex: 0,
    onRowsCountChange: function () { return undefined; },
    config: {
        isStickyHeader: false,
    },
};
exports.default = Table;
//# sourceMappingURL=Table.js.map